import { Dropdown } from "primereact/dropdown"
import CatSelect from "../../cat/CatSelect"
import { difficultyOptions, LETTERS } from "../../scr/const";
import { Checkbox } from "primereact/checkbox";
import { Menubar } from "primereact/menubar";
import { useEffect, useState } from "react";
import { InputNumber } from "primereact/inputnumber";
import CatService from "../../../service/CatService";
import { LabeledValue } from "../../common/LabeledValue";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";

export function QueBasic({question,courseId,questionType,onChange})
{
    const {t}=useTranslation();
    const queOptions=[];

    const [answerOptions,setAnswerOptions]=useState([]);
    const [options,setOptions]= useState(question.options);
    const [answer,setAnswer]= useState(question.answer);
    const [difficulty,setDifficulty]= useState(question.difficulty);
    const [weight,setWeight]= useState(question.weight);
    const [catId,setCatId]=useState(question.catId);
    const [mixOpts,setMixOpts]=useState(question.mixOpts);
    const [multipleOptions,setMultipleOptions]=useState(false);

    for(var c=2;c<20;c++)
        queOptions.push({value:c});

    useEffect(()=>{
        setAnswer(question.answer);
    },[question.answer]);
    useEffect(()=>{
        console.log('QueBasic:construstor');
    },[]);
    useEffect(()=>{
        var mop = questionType=='MC'||questionType=='MR';
        setMultipleOptions(mop);
        resetAnswerOptions(mop);
    },[options,questionType]);
    const changed=(q)=>{
        onChange(q);
    };
    const optionValueTemplate=(option,props)=>{
        if(option == undefined)
            return '';
        return( <LabeledValue label={t('Options')} value={option.value}/>);
    };
    const answerValueTemplate=(option,props)=>{
        return( <LabeledValue label={t('Answer')} value={option!=undefined?option.value:''}/>);
    };
    
    const difficultyValueTemplate=(option,props)=>{
        return( <LabeledValue label={t('Difficulty')} value={options!=undefined?option.label:''}/>);
    }

    const resetAnswerOptions=(mop)=>{
        var answers=[];
        if(mop)
        {
            for(var a=1;a<=options;a++)
                answers.push({value:LETTERS.substring(a-1,a)});    
        }
        if(questionType=='YN')
            answers.push({value:'YES'},{value:'NO'});
        if(questionType=='TF')
            answers.push({value:'TRUE'},{value:'FALSE'});

        setAnswerOptions(answers);        
    };
    const onOptionChange=(e)=>{
        setOptions(e.target.value);
        changed({options:e.target.value});
    };
    const onAnswerChange=(e)=>{
        setAnswer(e.target.value); 
        changed({answer:e.target.value});
    };
    const onDifficultyChange=(e)=>{
        setDifficulty(e.target.value); 
        changed({difficulty:e.target.value});
    };
    const onWeightChange=(e)=>{
        setWeight(e.target.value); 
        changed({weight:e.target.value});
    };
    const onCatSelect=(cat)=>{
        setCatId(cat.id);
        changed({catId:cat.id});
    }
    const onMixOptsChange=(e)=>{
        setMixOpts(e.target.checked);
        changed({mixOpts:e.target.value});
    };
    
    const answerInput=()=>{
        if(!multipleOptions)
        {            
            return(
            <div className="field col-6 md:col-3 p-inputgroup flex-1">
                <span className="text-primary p-inputgroup-addon bg-white">{t('Answer')}</span>
                <InputText className="w-full" placeholder={t('Answer')} value={answer} disabled/>
            </div>
            );
        }   
        else
        {
            return(
                <div className="field col-6 md:col-3">
                <Dropdown className="w-full" placeholder="Answer" value={answer} options={answerOptions} valueTemplate={answerValueTemplate}
                    optionLabel="value" optionValue="value" onChange={onAnswerChange}/>
                </div>
            );
        }
    };
    const diffOptions=()=>{
        return difficultyOptions.map((d)=>{return {label:t('@difficulty.'+d.value),value:d.value}});
    }
    return(
        <>
			<div className="formgrid grid p-2 pt-4 surface-ground">
				<div className="field col-12">
					<CatSelect inputId="catSelect" className="w-full" value={catId} parentId={courseId} onSelect={onCatSelect}></CatSelect>
				</div>
				<div className={'field col-6 md:col-3'+(multipleOptions?'':' hidden')}>
					<Dropdown className="w-full" value={options} placeholder="Options" valueTemplate={optionValueTemplate}
                        options={queOptions} optionLabel="value" optionValue="value" onChange={onOptionChange}/>
				</div>
				{
                    answerInput()
                }
				<div className="field col-6 md:col-3">
					<Dropdown className="w-full" placeholder={t('Difficulty')} value={difficulty} valueTemplate={difficultyValueTemplate} 
                        options={diffOptions()} onChange={onDifficultyChange}/>
				</div>
                <div className="field col-12 p-inputgroup flex-1">
                    <span className="p-inputgroup-addon text-primary bg-white" style={{width:'80px'}}>{t('Weight')}</span>
					<InputNumber className="w-full" value={weight} placeholder={t('Weight')} onValueChange={onWeightChange} mode="decimal" minFractionDigits={1}/>
                </div>                
            </div>
        </>
    )
}